import {Destroyable} from '../common';
import {XEventListener, IEventTarget, EVENT_LISTENER_ORDER} from './event.interface';

/**
 * 只能先“订阅”再“发布”
 * 全局对象会产生命名冲突
 * 观察者模式有两个明显的优点
 * 时间上解耦
 * 对象间解耦
 * 它应用广泛，但是也有缺点
 * 创建这个函数同样需要内存，过度使用会导致难以跟踪维护
 */
export class BaseEventTarget extends Destroyable implements IEventTarget {
  private _map: Map<string, Array<XEventListener>>;

  constructor() {
    super();
    this._map = new Map();
    this.onDestroy(() => {
      if (this._map) {
        this._map.clear();
        this._map = null;
      }
    }, EVENT_LISTENER_ORDER);
  }

  addEventListener(eventName: string, listener: XEventListener): IEventTarget {
    if (this.usable && eventName && listener) {
      if (this._map.has(eventName)) {
        this._map.get(eventName).push(listener);
      } else {
        this._map.set(eventName, [listener]);
      }
    }
    return this;
  }

  removeEventListener(eventName: string, listener?: XEventListener) {
    if (this.usable && this._map.has(eventName)) {
      const fns = this._map.get(eventName);
      if (!listener) { // 如果没有传入fn回调函数，直接取消key对应消息的所有订阅
        fns.splice(0, fns.length);
      } else {
        while (fns.includes(listener)) { // 针对一个处理函数绑定多次的情况
          fns.splice(fns.indexOf(listener), 1);
        }
      }
    }
  }

  dispatchEvent(eventName: string, ...args: Array<any>) {
    if (this.usable && this._map.has(eventName)) {
      this._map.get(eventName).forEach((value) => {
        try {
          value.apply(this, args); // 循环回调数组执行回调函数
        } catch (e) {
          console.error(e);
        }
      });
    }
  }

}
